var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lable-name-book"},[_c('span',[_vm._v("【")]),_c('p',{staticClass:"name",attrs:{"id":_vm.tooltipId},on:{"click":function($event){$event.stopPropagation();}}},[_vm._v(_vm._s(_vm.title))]),_c('span',[_vm._v("】")])])}
var staticRenderFns = []

export { render, staticRenderFns }